import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommentReactionModule } from '../common/comment-reaction/comment-reaction.module';
import { ProfileImageModule } from '../common/profile-image/profile-image.module';
import { ScrollModule } from '../common/scroll/scroll.module';
import { ReactionDetailsComponent } from './reaction-details.component';
import { ReactionDetailsDialogComponent } from './reaction-details.dialog';

@NgModule({
  declarations: [ReactionDetailsComponent, ReactionDetailsDialogComponent],
  exports: [ReactionDetailsComponent, ReactionDetailsDialogComponent],
  imports: [
    CommentReactionModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatPaginatorModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    ProfileImageModule,
    ScrollModule,
  ],
})
export class ReactionDetailsModule {}
